/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SyncResult
 */
export interface SyncResult {
    /**
     * Anzahl synchronisierter Einträge
     * @type {number}
     * @memberof SyncResult
     */
    syncedCount?: number;
    /**
     * Zeitpunkt der Synchronisation
     * @type {Date}
     * @memberof SyncResult
     */
    syncedAt?: Date;
}

/**
 * Check if a given object implements the SyncResult interface.
 */
export function instanceOfSyncResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SyncResultFromJSON(json: any): SyncResult {
    return SyncResultFromJSONTyped(json, false);
}

export function SyncResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): SyncResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'syncedCount': !exists(json, 'syncedCount') ? undefined : json['syncedCount'],
        'syncedAt': !exists(json, 'syncedAt') ? undefined : (new Date(json['syncedAt'])),
    };
}

export function SyncResultToJSON(value?: SyncResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'syncedCount': value.syncedCount,
        'syncedAt': value.syncedAt === undefined ? undefined : (value.syncedAt.toISOString()),
    };
}

